import { SQDCEABName } from "@/graphql";
import { useSQDCGlobalSettings } from "@/modules/sqdc/helper/useSQDCGlobalSettings";

export function useTranslationFunctionCode() {
  const { settings } = useSQDCGlobalSettings();

  return (functionCode: string) => {
    if (functionCode === "EABName") {
      return (settings.value?.eabName ?? SQDCEABName.LEGACY) === SQDCEABName.LEGACY
        ? "views.KPIBoard.psButton"
        : "views.KPIBoard.actionBoard";
    }
    return undefined;
  };
}
